// A draft set aside: a comment the reviewer keeps for themselves, such as a
// conversation with their local agent, that is not for the review. It
// stays a draft (not included, so no publish sends it), out of the Review
// view's Unsent list and the header's counts, listed folded under Asides
// and shown collapsed in place. Private to the reviewer, a flag kept with
// their review marks (flags.ts):
//
//   path  `./aside/<draft ID>`;
//   blob  a digest of the draft ID (a flag's blob must be a SHA-1's shape).
//
// Bringing it back removes the flag; including it brings it back.
import type { ReviewDraft } from '../api/server';
import type { Anchor, Plan } from './anchors';
import { digest, flag } from './flags';

/** Where asides' paths start. */
export const ASIDE_PATH = './aside/';

const pathOf = (id: ReviewDraft['id']) => ASIDE_PATH + String(id);

/** The flag that sets draft `id` aside. */
export const asideAnchor = (id: ReviewDraft['id']): Anchor => flag(pathOf(id), digest(`aside\0${String(id)}`));

/** The IDs (as strings) of the drafts set aside. */
export const asideIds = (flags: readonly Anchor[]): ReadonlySet<string> =>
  new Set(flags.flatMap((a) => (a.path.startsWith(ASIDE_PATH) ? [a.path.slice(ASIDE_PATH.length)] : [])));

/** The writes that set draft `id` aside, or bring it back (dropping every flag on it). */
export function planAside(id: ReviewDraft['id'], flags: readonly Anchor[], aside: boolean): Plan {
  const path = pathOf(id);
  return { unset: aside ? [] : flags.filter((a) => a.path === path), set: aside ? [asideAnchor(id)] : [] };
}
